<template lang="pug">
bottom-modal(:id="modalId", width="w-xtra-large", :loading="onLoading(loaderKey)")
    span(slot="header-text") {{ modalHeader }}
    template(v-if="step==='filter'")
      div(slot="body")
        .container(v-if="isActive")
          .row
            .col-md-3
              filter-sidebar(:updateFilters="updateFilters", :onAddAllChange="setAddAllMatch")

            .col-md-9
              .alert.alert-info
                v-loading(loader="fetch-override-pricebook-products-count")
                  template(v-if="productsPoolCount > 0")
                    | {{ productsPoolCount }} products match the filters
                  template(v-else)
                    | No products under the applied filters

              v-server-table(
                :url="productsUrl",
                :columns="columns",
                :options="tableOptions",
                :name="tableName",
                ref="datatable"
              )
                template(slot="select", slot-scope="props")
                  label.md-check
                    input(
                      :disabled="addAllMatching"
                      type="checkbox",
                      :checked="props.row.selected",
                      v-model="selectedProducts",
                      :value="props.row")
                    i.indigo

      button.btn.btn-fw.primary(slot="footer", @click="displayOverrideForm") Next

    template(v-else)
      div(slot="body")
        .container
          .alert.alert-info
            | Adding {{ productsToAddCount }} products to pricebook
          .row
            .col-md-12
              override-values-form(:onChange="onOverrideValuesChange")

      button.btn.btn-fw.primary(
        slot="footer",
        @click="saveEntries",
        :disabled="onLoading(loaderKey)")
        v-loading(:loader="loaderKey") Save

</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import OverrideValuesForm from './batch/override-values-form';
import FilterSidebar from '../pricebook/template/filter-sidebar';

export default {
    components: {
        OverrideValuesForm,
        FilterSidebar,
    },

    props: {
        pricebookId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            isActive: false,
            updateMode: 0,
            step: 'filter',
            addAllMatching: false,
            overrideEntry: {
                price_adjustment_mode: 'none',
                price: null,
            },
            selectedProducts: [],
            filters: {
                category: null,
                tags: [],
                search: null,
            },
            tableName: 'OVERRIDE_PRICEBOOK_PRODUCTS_POOL',
            columns: ['select', 'code', 'name', 'description'],
        };
    },

    computed: {
        modalId() {
            return 'batch-products-popup';
        },
        modalHeader() {
            return this.updateMode
                ? this.trans('station_pricebook.update_override_products')
                : this.trans('station_pricebook.add_override_products');
        },
        loaderKey() {
            return this.updateMode
                ? 'update-batch-override-entries'
                : 'add-batch-override-entries';
        },
        tableOptions() {
            return {
                filterable: false,
                params: {
                    category_id: this.filters.category,
                    query: this.filters.search,
                    tag_ids: this.filters.tags.map(t => t.id),
                    update_only: this.updateMode,
                },
            };
        },
        productsUrl() {
            return Laroute.route(
                'franchise.inventory.override_pricebook.products_pool',
                {
                    id: this.pricebookId,
                },
            );
        },
        productsToAddCount() {
            return this.addAllMatching
                ? this.productsPoolCount
                : this.selectedProducts.length;
        },
        ...mapGetters('override_pricebook', ['productsPoolCount']),
    },
    created() {
        this.$on('show', updateMode => {
            this.isActive = true;
            this.reset(updateMode);
            this.refreshProductsCount();
            this.showModal();
        });
    },
    mounted() {
        $(`#${this.modalId}`).on('hide.bs.modal', () => {
            this.isActive = false;
            this.addAllMatching = false;
        });
    },
    methods: {
        showModal() {
            $(`#${this.modalId}`).modal('show');
        },
        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },
        refreshProducts() {
            this.$refs.datatable.refresh();
        },
        reset(updateMode) {
            this.updateMode = updateMode;
            this.step = 'filter';
            this.overrideEntry = {
                price_adjustment_mode: 'none',
                price: null,
            };
            this.selectedProducts = [];
            this.filters.category = null;
            this.filters.tags = [];
            this.filters.search = null;
        },
        refreshProductsCount() {
            let params = {
                pricebookId: this.pricebookId,
                filters: {
                    category_id: this.filters.category,
                    query: this.filters.search,
                    tag_ids: this.filters.tags.map(t => t.id),
                    update_only: this.updateMode,
                },
            };
            this.getOverridePricebookProductsCount(params);
        },
        refreshFilters() {
            // Workaround because the params doesn't seems to be
            // updated when changed within the same event bus
            // this.refreshProducts();
            this.$nextTick(this.refreshProducts);
            this.refreshProductsCount();
        },
        updateFilters(filters) {
            this.filters = filters;
            this.refreshFilters();
        },
        setAddAllMatch(addAll) {
            this.addAllMatching = addAll;
        },
        onOverrideValuesChange: function(val) {
            this.overrideEntry = val;
        },
        displayOverrideForm() {
            this.step = 'set-values';
        },
        async saveEntries() {
            try {
                let filters = this.addAllMatching
                    ? {
                          category_id: this.filters.category,
                          tag_ids: this.filters.tags.map(t => t.id),
                          query: this.filters.search,
                      }
                    : {
                          product_ids: this.selectedProducts.map(p => p.id),
                      };

                let params = {
                    pricebookId: this.pricebookId,
                    filters: filters,
                    params: this.overrideEntry,
                };

                if (this.updateMode) {
                    await this.updateBatchEntries(params);
                } else {
                    await this.addBatchEntries(params);
                }
                this.showToastrSuccess();
                this.hideModal();
                this.$emit('entry-saved');
            } catch (e) {
                this.showApiError(e);
            }
        },
        ...mapActions('override_pricebook', [
            'getOverridePricebookProductsCount',
            'addBatchEntries',
            'updateBatchEntries',
        ]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/add-products-form.vue